var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4734 6.80667C14.3482 6.68046 14.1778 6.60947 14 6.60947C13.8223 6.60947 13.6519 6.68046 13.5267 6.80667L8.56002 11.78L6.47336 9.68667C6.2983 9.51756 6.04632 9.45469 5.81234 9.52175C5.57836 9.5888 5.39792 9.77559 5.339 10.0117C5.28008 10.2479 5.35163 10.4976 5.52669 10.6667L8.08669 13.2267C8.21187 13.3529 8.38226 13.4239 8.56002 13.4239C8.73778 13.4239 8.90818 13.3529 9.03336 13.2267L14.4734 7.78667C14.6102 7.66046 14.688 7.4828 14.688 7.29667C14.688 7.11053 14.6102 6.93288 14.4734 6.80667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckActive);
export default __webpack_public_path__ + "static/media/check-active.3dbd7321ac839e16a36bd25332c64f1c.svg";
export { ForwardRef as ReactComponent };